import classNames from 'classnames';
import React, { FC, memo, ReactNode } from 'react';

type PropTypes = {
  steps: {
    name: string;
    icon: ReactNode;
  }[];
  pageStep?: string;
};

const UserCreateSteps: FC<PropTypes> = ({ steps, pageStep }) => {
  return (
    <div className="user-create__navigation">
      {steps.map((step, index) => (
        <React.Fragment key={step.name}>
          <div
            className={classNames('user-create__step', {
              previously: index + 1 < Number(pageStep),
              active: index + 1 === Number(pageStep),
            })}
          >
            <div className="user-create__step-icon">{step.icon}</div>
            <div className="user-create__step-name">{step.name}</div>
          </div>

          {index < steps.length - 1 && (
            <div
              className={classNames('user-create__separator', {
                previously: index + 1 < Number(pageStep),
              })}
            ></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default memo(UserCreateSteps);
